import React, { Component } from "react";
import SimpleInput from "../../../../modules/SimpleInput";
import SimpleDDL from "../../../../modules/SimpleDDL";
import SimpleDate from "../../../../modules/SimpleDate";
import { ACTIVITY_TYPE } from "../../../common/Constants";

class CrmSystem extends Component {
  render() {
    const { options, controls, setValue, errors, box, activityType } =
      this.props;

    return (
      <React.Fragment>
        <div className="grid grid-3x gap-20px">
          <div id="grid-1">
            <SimpleInput
              name="kodeCabang"
              label="Kode Cabang"
              readOnly
              value={controls?.kodeCabang?.value}
            />
            <SimpleInput
              name="prospectDate"
              label="Tanggal Prospek"
              readOnly
              value={controls?.prospectDate?.value}
            />
            <SimpleInput
              name="prospectId"
              label="Nomor Prospek"
              readOnly
              value={controls?.prospectId?.value}
            />
            {box === "CDB" ? (
              <React.Fragment>
                <SimpleInput
                  name="lastFUStatusH1"
                  label="Status FU Terakhir H1"
                  readOnly
                  value={controls?.lastFUStatusH1?.value}
                />
                <SimpleInput
                  name="lastFUStatusH23"
                  label="Status FU Terakhir H23"
                  readOnly
                  value={controls?.lastFUStatusH23?.value}
                />
                <SimpleInput
                  name="lastFUDate"
                  label="Tanggal FU Terakhir"
                  readOnly
                  value={controls?.lastFUDate?.value}
                />
              </React.Fragment>
            ) : (
              <React.Fragment>
                <SimpleDDL
                  id="select_options_prospek_category"
                  box="search"
                  name="category"
                  label="Kategori Prospek"
                  mandatory
                  errorMessage={errors?.category}
                  readOnly={true}
                  options={options.prospekCategoryOptions}
                  value={controls?.category?.value || null}
                  onChange={(value, { name }) => {}}
                />
              </React.Fragment>
            )}
          </div>
          <div id="grid-2">
            <SimpleDDL
              id="select_options_prospek_source"
              box="search"
              name="source"
              label="Asal Prospek"
              mandatory
              errorMessage={errors?.source}
              readOnly={
                !(box === "FU" && activityType === ACTIVITY_TYPE.CREATE)
              }
              options={options.prospekSourceCreateOptions}
              value={controls?.source?.value || null}
              onChange={(value, { name }) => setValue(name, value)}
            />
            <SimpleInput
              name="sourceCabang"
              label="Cabang Asal"
              readOnly
              value={controls?.sourceCabang?.value}
            />
            <SimpleInput
              name="lastFollowUpBy"
              label="Last Follow Up By"
              readOnly
              value={controls?.lastFollowUpBy?.value}
            />
            <SimpleDDL
              id="select_options_prospek_type"
              box="search"
              name="type"
              label="Jenis Prospek"
              value={controls?.type?.value || null}
              readOnly
            />
            <SimpleInput
              name="tanggalServiceTerakhir"
              label="Tanggal Service Terakhir"
              value={controls?.tanggalServiceTerakhir?.value || null}
              readOnly
            />
            {box === "CDB" && (
              <React.Fragment>
                <SimpleDate
                  name="lastBuyDate"
                  label="Tanggal Beli Terakhir"
                  disabled
                  date={controls?.lastBuyDate?.value}
                />
                <SimpleDate
                  name="lastServiceDate"
                  label="Tanggal Service Terakhir"
                  disabled
                  date={controls?.lastServiceDate?.value}
                />
              </React.Fragment>
            )}
          </div>
          <div id="grid-3">
            {box === "CDB" && (
              <SimpleInput
                name="sourceData"
                label="Sumber Data"
                readOnly
                value={controls?.sourceData?.value}
              />
            )}
            <SimpleInput
              name="prospectOwnership"
              label="Pemilik Prospek"
              value={controls?.prospectOwnership?.value}
              readOnly
            />
            <SimpleInput
              name="lastSeller"
              label="Penjual Terakhir"
              readOnly
              value={controls?.lastSeller?.value}
            />
            <SimpleInput
              name="lastLoginDate"
              label="Last Login Date"
              readOnly
              value={null}
            />
            <SimpleInput
              name="lastLoginTime"
              label="Last Login Time"
              readOnly
              value={null}
            />
            {box === "CDB" && (
              <React.Fragment>
                <SimpleDate
                  name="lastLoginDate"
                  label="Last Login Date"
                  disabled
                  date={controls?.lastLoginDate?.value}
                />
                <SimpleDate
                  name="lastLoginTime"
                  label="Last Login Time"
                  disabled
                  date={controls?.lastLoginTime?.value}
                />
              </React.Fragment>
            )}
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default CrmSystem;
